import { request } from '@tencent/ppd-base-libs';

export function getUserInfo() {
  return request.get('/cgi-bin/lottery/ia_lottery_qry_user_lottery.cgi');
}

/**
 * 获取系统配置
 * @returns
 */
export const getConfig = async () => {
  const url = `https://st.moneydata.hk/res/cc/goodDeedDay/config.json?v=${new Date().getTime()}`;
  const data = await request.loadVtools(url);
  return data;
};
